/**
 * Offer page routes used across the takeover system.
 * Shared by SiteTakeoverPageBanner, SiteTakeoverPopup, and individual takeover banner components.
 */
export const offerPageRoutes: Array<string> = [
  '/:regionCode/offer/:slug/:offerId',
  '/:regionCode/cruises/:offerId',
  '/:regionCode/cruises/:slug/:offerId',
  '/:regionCode/tour/:offerId',
  '/:regionCode/tour/:slug/:offerId',
  '/:regionCode/partner/:slug/:offerId',
]
